import { Injectable } from '@angular/core';

@Injectable()
export class Configuration {
    public Server: string = window.location.protocol + '//' + window.location.host + '/';
    public ApiUrl: string = "api/";
    public ServerWithApiUrl = this.Server + this.ApiUrl;
}

export class AuthConsts {
    public static CLIENT_ID: string = "457cac3d-5d61-4796-ac88-bbbd4cd4fbd2";
    public static TENANT_ID: string = "f0f4e1d1-e064-46f7-89fc-9c0d12b8d0b7";
    public static GRAPH_RESOURCE: string = "http://cbpgdatdevreguiweb.azurewebsites.net";
}


/** WEBPACK FOOTER **
 ** ./app/app.constants.ts
 **/